import { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { atom, useRecoilState } from "recoil";
import { fetchAuth, setFiresotreUser } from "../actions";
import * as API from "../api/api";

export const userState = atom({
  key: "userState",
  default: { uid: "", firestoreUser: undefined, authUser: undefined },
});

export const useCheckAuth = () => {
  const [recoilUser, setRecoilUser] = useRecoilState(userState);
  const dispatch = useDispatch();
  const checkAuth = useCallback(() => {
    console.log(recoilUser.authUser);
    if (recoilUser.authUser) {
      if (recoilUser.authUser.email === "tipsnap@admin.com") {
        dispatch(fetchAuth(true, "admin"));
      } else if (recoilUser.firestoreUser?.authType) {
        dispatch(fetchAuth(true, recoilUser.firestoreUser.authType));
      } else {
        dispatch(fetchAuth(false));
      }
    } else {
      dispatch(fetchAuth(false));
    }
  }, [recoilUser]);
  return checkAuth;
};

export const useReloadFirestoreUser = () => {
  const [recoilUser, setRecoilUser] = useRecoilState(userState);
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      const firestoreUser =
        recoilUser?.uid && (await API.get_user(recoilUser.uid));
      if (firestoreUser) {
        dispatch(setFiresotreUser(firestoreUser));
        setRecoilUser((state) => ({ ...state, firestoreUser }));
      }
    })();
  }, [recoilUser.uid]);
};

export const useIsAuth = () => {
  const [recoilUser, setRecoilUser] = useRecoilState(userState);
  const isAuth = useMemo(() => {
    if (recoilUser.authUser?.email === "tipsnap@admin.com") {
      return true;
    }
    if (recoilUser.firestoreUser?.authType) {
      return true;
    }
  }, [recoilUser.authUser, recoilUser.firestoreUser]);
  return isAuth;
};
